// Cart.js
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import api from 'api';
import OrderItems from 'components/orders/helpers/OrderItems'
import { formatPrice, debug } from './../../utils';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import './cart.css';
import { loadCart } from '../../redux/cartSlice';
function Cart() {
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const [openItems, setOpenItems] = useState({});
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(loadCart());
  }, [user.isSignedIn]);
  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const handleRemoveItem = async (item) => {
    try {
      const result = await Swal.fire({
        title: 'Retrait du panier',
        html: t('Confirmez-vous le retrait du panier cette&nbsp;formalité&nbsp;?'),
        showCancelButton: true,
        confirmButtonText: 'Oui, supprimer',
        cancelButtonText: 'Annuler',
        icon: undefined,
        buttonsStyling: false, // important pour utiliser tes classes
        customClass: {
          popup: 'swal2-no-icon',
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary ms-2'
        }
      });

      if (!result.isConfirmed) return;
      // appel API
      const response = await api.delete(`/cart/item/${item.itId}`);

      // reload panier
      dispatch(loadCart());
      // info succès
      Swal.fire({
        html: response?.data?.message || 'Item retiré du panier',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        icon: undefined, // aucune icône
        customClass: {
          popup: 'swal2-no-icon'
        }
      });
    } catch (err) {
      Swal.fire({
        text: t(err.response?.data?.error?.message || 'Une erreur est survenue'),
        icon: undefined
      });
    }
  };
  return (
    <div className="cart">
      {/* PANIER VIDE */}
      {cart.items.length === 0 && (
        <div className='text-center'>
          <div className='pt-5 pb-3 text-brand-primary'>
            Votre panier ne contient aucune formalité.
          </div>
          <Link to="/" className="btn btn-primary rounded-pill text-nowrap">
            {t('Add products')}
          </Link>
        </div>
      )}
      {/* PANIER */}
      {cart.items.length > 0 && (
        <OrderItems
          items={cart.items}
          totalPriceET={cart.totalPriceET}
          orderVATAmount={cart.orderVATAmount}
          totalPriceIT={cart.totalPriceIT}
          onRemoveItem={handleRemoveItem}
        />
      )}
    </div>
  );
}
export default Cart;